import { apiRefresh } from 'api/auth';
import { tzAxios } from 'api/axios';

export const withTokenRefresh = async <T>(apiCall: () => Promise<T>): Promise<T> => {
  try {
    return await apiCall();
  } catch (error: any) {
    if (error?.response?.status === 401) {
      const refreshToken = localStorage.getItem('_auth_refresh');
      if (refreshToken) {
        try {
          const refreshed = await apiRefresh({ refreshToken });
          tzAxios.defaults.headers.common.Authorization = `Bearer ${refreshed.accessToken}`;
          return await apiCall();
        } catch (refreshError) {
          throw error;
        }
      }
    }
    throw error;
  }
};
